// extracted by mini-css-extract-plugin
export default {"accountDropDown":"accountDropDown_accountDropDown__V8dx1","userType":"accountDropDown_userType__X1nIg","nameSurnameDateWrapper":"accountDropDown_nameSurnameDateWrapper__nPxR0"};